import React from 'react';
import { Progress } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import { transformPx2Rem, convertStyleData } from '@utils/tools';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { RequestStatus } from 'src/common/request-status/RequestStatus';
import { LoadingBtn } from 'src/common/loading-btn/LoadingBtn';

import './SeckillCustomComponent.less';

/**
 * type: 'seckill'
 * 组件：秒杀组件
 */
export default class SeckillCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    const compindex = props.index;
    const pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let isTimeline = false;
    let that = this;
    let compData = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    if (pageInstance.timelineComps && pageInstance.timelineComps.length) {
      for (let item of pageInstance.timelineComps) {
        if (customFeature.id == pageInstance.data.eles[item.compindex].customFeature.timeline_object){
          isTimeline=true;
        }
      }
    };
    if (!isTimeline){
      let param = {};
      let newdata = {};
      newdata['eles[' + compindex + '].loading'] = true;
      newdata['eles[' + compindex + '].loadingFail'] = false;
      newdata['eles[' + compindex + '].goods_data'] = [];
      newdata['eles[' + compindex + '].is_more'] = 1;
      newdata['eles[' + compindex + '].curpage'] = 0;

      param.form =  "goods";
      param.goods_type = 0;
      param.page_size = customFeature.loadingNum || 10;
      param.is_seckill = 1;
      param.page = 1;
      param.is_integral = customFeature.isIntegral ? 1 : 0;
      param.is_count = 0;
      param.seckill_activity_arr = {
        seckill_activity_id: customFeature.seckillActive,
        seckill_activity_time_type:6,
      };
      param.is_seckill_activity = customFeature.seckillType == 'activeSeckill' ? 1 : 0 ;

      if (customFeature.source && customFeature.source != 'none') {
        param.idx_arr = {
          "idx": "category",
          "idx_value": customFeature.source
        }
      }

      newdata['eles[' + compindex + '].seckill_activity_arr'] = param.seckill_activity_arr;
      if (customFeature.seckillType === 'activeSeckill' && customFeature.isShowFranchiseeGoods && !pageInstance.franchiseeId) { // 查询子店秒杀商品(排除子店功能页)
        this.checkActivityIsFranchisee(customFeature.seckillActive).then(flag => {
          if (flag) {
            param['is_app_shop_seckill'] = 1;
          }
          newdata['eles[' + compindex + '].param'] = param;
          pageInstance.setData(newdata);
          that.initSeckillList(compindex, param, pageInstance);
        }).catch(err => {
          console.log(err);
        });
      }else {
        newdata['eles[' + compindex + '].param'] = param;
        pageInstance.setData(newdata);
        this.initSeckillList(compindex, param, pageInstance);
      }
    }
  }

  seckillScrollFunc = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex       = typeof event == 'object' ? event.currentTarget.dataset.compindex : event;
    let compData     = pageInstance.data.eles[compindex];
    let curpage      = compData.curpage + 1;
    let customFeature = compData.customFeature;
    let newdata      = {};
    let param        = compData.param;
    let that         = this;

    if(!compData.is_more && typeof event == 'object' && event.type == 'tap'){
      app.showModal({
        content: '已经加载到最后了'
      });
    }
    if (compData.loading || !compData.is_more) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);


    param.page_size = +customFeature.loadingNum || 10;
    param.page = curpage;
    param.seckill_activity_arr = compData.seckill_activity_arr;
    param.is_seckill_activity = customFeature.seckillType == 'activeSeckill' ? 1 : 0;

    app.sendRequest({
      url: '/index.php?r=AppShop/GetGoodsList',
      data: param,
      method: 'post',
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        newdata = {};
        let rdata = res.data,
            appId = app.getAppId(),
            downcountArr = pageInstance.downcountObject[compindex] || [];

        if(rdata){
          for (let i = 0; i < rdata.length; i++) {
            let f = rdata[i].form_data,
                dc ,
                idx = (curpage-1) * param.page_size + i;

            f.description = '';
            f.downCount = {
              hours : '00' ,
              minutes : '00' ,
              seconds : '00'
            };
            if(f.seckill_start_state == 0){
              dc = app.beforeSeckillDownCount(f , pageInstance , 'eles[' + compindex + 'goods_data[' + idx + '].form_data');
            }else if(f.seckill_start_state == 1){
              dc = app.duringSeckillDownCount(f , pageInstance , 'eles[' + compindex + ']goods_data[' + idx + '].form_data');
            }
            dc && downcountArr.push(dc);
            if (customFeature.style == 2 && customFeature.mode == 0) {
              rdata[i].form_data = that.seckillStartTimeView(f);
            }
            if (+param.is_app_shop_seckill === 1 && f.app_id !== appId) {
              f.isSubShopGoods = true;
            } else {
              f.isSubShopGoods = false;
            }
          }
          newdata['eles[' + compindex + '].goods_data'] = compData.goods_data.concat(res.data);
          newdata['eles[' + compindex + '].is_more'] = res.is_more ? res.is_more : 0;
          newdata['eles[' + compindex + '].curpage']    = res.current_page;
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;
          pageInstance.downcountObject[compindex] = downcountArr;

          pageInstance.setData(newdata);
        }
      },
      fail: function () {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function () {
      }
    })
  }

  /** 设置模板消息提醒功能*/
  formSubmitRemind = (e) => {
    let formid = '';
    let data = e.currentTarget.dataset;
    let goodsInfo = JSON.parse(data.goods);
    let pageInstance = app.getAppCurrentPage();
    let newData={};
    let loaclDayTime = new Date(new Date().toLocaleDateString()).getTime() / 1000;
    let seventDay = 86400*7;
    if (goodsInfo.seckill_start_timestamp > loaclDayTime + seventDay){
      app.showModal({ content: '请于开抢前7天来设置哦' });
      return;
    }
    if (e.target.formId != 'the formId is a mock one') {
      formid = e.target.formId
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/setActivityGoodsCare',
      method: 'post',
      data: {
        data_id: goodsInfo.id,
        activity_type: 1,
        activity_id: goodsInfo.seckill_activity_id,
        seckill_activity_arr: {
          seckill_activity_time_id: goodsInfo.seckill_activity_time_id,
          form_id: formid,
        },
        is_deleted:data.is_deleted,
      },
      success: function (res) {
        if (!res.status) {
          if (data.is_deleted == 0){
            app.showModal({
              title: '提示',
              content: '开抢前3分钟提醒你哦',
              showCancel:false,
            })
            newData['eles[' + data.compindex + '].goods_data[' + data.index + '].form_data.is_seckill_activity_care'] = 1;
            newData['eles[' + data.compindex + '].goods_data[' + data.index + '].form_data.seckill_activity_care'] = pageInstance.data.eles[data.compindex].goods_data[data.index].form_data.seckill_activity_care + 1;

            }else{
              app.showToast({
                title: '提醒已取消',
              })
              newData['eles[' + data.compindex + '].goods_data[' + data.index + '].form_data.is_seckill_activity_care'] = 0;
              newData['eles[' + data.compindex + '].goods_data[' + data.index + '].form_data.seckill_activity_care'] = pageInstance.data.eles[data.compindex].goods_data[data.index].form_data.seckill_activity_care - 1;
            }
            pageInstance.setData(newData);

          }
        },
      })
  }

  /** 跳转秒杀详情*/
  goSeckillDetail = (e) => {
    let data = JSON.parse(e.currentTarget.dataset.formdata);
    let appId = e.currentTarget.dataset.appId;
    let franchisee = app.getPageFranchiseeId();
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    if (appId && appId !== app.getAppId() && chainParam === '') { // 子店秒杀商品
      chainParam = '&franchisee=' + appId;
    }
    if (data.seckill_start_state !=2){
      let path = '/seckill/pages/seckillDetail/seckillDetail?id=' + data.id + '&sec_act_id=' + data.seckill_activity_id + '&sec_t_id=' + data.seckill_activity_time_id + '&secType=' + e.currentTarget.dataset.seckilltype + chainParam;
      app.turnToPage(path);
    }else{
      app.showModal({ content: '该商品秒杀活动已结束' });
    }
  }

  /**
   * 秒杀倒计时显示处理
  */
  seckillStartTimeView = (goods) => {
    let loaclDayTime = new Date(new Date().toLocaleDateString()).getTime() / 1000;
    let tomorrowTime = loaclDayTime + 86400;
    let afterTomorrowTime = tomorrowTime + 86400;
    let date = new Date(goods.seckill_start_timestamp * 1000);
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let h = date.getHours();
    let min = date.getMinutes();
    goods.seckill_startTime = '';
    if (goods.seckill_start_timestamp <= tomorrowTime) {
      goods.startDay = 1;
    } else if (goods.seckill_start_timestamp > tomorrowTime && goods.seckill_start_timestamp <= afterTomorrowTime) {
      goods.startDay = 2;
      if (min == '00') {
        goods.seckill_startTime = '明日' + h + '点整开抢';
      } else if (min != '00' && min<10){
        goods.seckill_startTime = '明日' + h + ':0' + min + '开抢'
      } else {
        goods.seckill_startTime = '明日' + h + ':' + min + '开抢'
      }
    } else if (goods.seckill_start_timestamp > afterTomorrowTime) {
      goods.startDay = 2;
      if (min == '00') {
        goods.seckill_startTime = m + '月' + d + '日' + h + '点整开抢';
      } else if(min != '00' && min < 10){
        goods.seckill_startTime = m + '月' + d + '日' + h + ':0' + min + '开抢';
      } else {
      goods.seckill_startTime = m + '月' + d + '日' + h + ':' + min + '开抢';
      }
    }
    return goods;
  }

    /**
   * 第一次初始化秒杀列表
   */
  initSeckillList = (compindex, param, pageInstance) => {
    let that = this;
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetGoodsList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let rdata = res.data,
          appId = app.getAppId(),
          customFeature = pageInstance.data.eles[compindex].customFeature,
          downcountArr =  pageInstance.downcountObject[compindex] || [],
          newdata = {};
        if (rdata) {
          for (let i = 0; i < rdata.length; i++) {
            let f = rdata[i].form_data,
              dc;

            f.description = '';
            f.downCount = {
              hours: '00',
              minutes: '00',
              seconds: '00'
            };
            if (f.seckill_start_state == 0) {
              dc = app.beforeSeckillDownCount(f, pageInstance, 'eles[' + compindex + ']goods_data[' + i + '].form_data');
            } else if (f.seckill_start_state == 1) {
              dc = app.duringSeckillDownCount(f, pageInstance, 'eles[' + compindex + ']goods_data[' + i + '].form_data');
            }
            dc && downcountArr.push(dc);
            if (customFeature.style == 2 && customFeature.mode == 0) {
              if (customFeature.style == 2 && customFeature.mode == 0) {
                rdata[i].form_data = that.seckillStartTimeView(f);
              }
            }
            if (+param.is_app_shop_seckill === 1 && f.app_id !== appId) {
              f.isSubShopGoods = true;
            } else {
              f.isSubShopGoods = false;
            }
          }
          newdata['eles[' + compindex + '].goods_data'] = res.data;
          newdata['eles[' + compindex + '].is_more'] = res.is_more ? res.is_more : 0;
          newdata['eles[' + compindex + '].curpage'] = 1;
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;
          
          pageInstance.downcountObject[compindex] = downcountArr;
          pageInstance.setData(newdata);
        }
      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  }

  /**
   * 查询活动是否为多店活动
   */
  checkActivityIsFranchisee = (activityId) => {
    return new Promise((resolve, reject) => {
      if (!activityId) {
        reject(false);
      }
      let seckillActivityObjectMap = app.globalData.seckillActivityObjectMap;
      if (seckillActivityObjectMap === undefined) {
        seckillActivityObjectMap = app.globalData.seckillActivityObjectMap = {};
      }
      if (seckillActivityObjectMap[activityId] !== undefined) {
        resolve(seckillActivityObjectMap[activityId]);
      }
      app.sendRequest({
        url: '/index.php?r=AppMarketing/GetSeckillActivityTitle',
        data: {
          activity_id: activityId
        },
        success: (res) => {
          if (res.status === 0) {
            if (Array.isArray(res.data) && res.data[0]) {
              seckillActivityObjectMap[activityId] = res.data[0]['is_app_shop_seckill'] > 0;
            }else {
              seckillActivityObjectMap[activityId] = false;
            }
            resolve(seckillActivityObjectMap[activityId]);
          }else {
            resolve(false);
          }
        },
        fail: reject
      })
    });
  }



  render() {
    const data = this.props.data;
    let {
      customFeature, goods_data, curpage
    } = data;
    const {
      mode, everyoneLimited, limited, peopleCounting
    } = customFeature;

    const styleObj = convertStyleData(data.style);
    if (customFeature.vesselAutoheight == 0) {
      styleObj['height'] = transformPx2Rem(customFeature['height'], 320);
    }
    /**
     * @desc 图片样式转换
     */
    const imgStyleObj = {
      width: transformPx2Rem(customFeature.imgWidth, 320),
      height: transformPx2Rem(customFeature.imgHeight, 320)
    };

    // 内容部分的宽度
    let title_width = null;
    switch (mode) {
      case 0:
        title_width = {width: `calc(100% - ${ imgStyleObj.width })`};
        break;
      case 2:
        title_width = {width: `${ imgStyleObj.width }`};
        break;
      default:
        title_width = {width: `calc(100% - ${ imgStyleObj.width })`};
        break;
    }

    /**
     * @desc 列表样式转换
     */
    const listStyleObj = {
      marginBottom: transformPx2Rem(customFeature.margin, 320),
      height: transformPx2Rem(customFeature.lineHeight, 320),
      backgroundColor: customFeature.lineBackgroundColor
    };
    const modeZero = () => (
      <div>
        {goods_data && goods_data.map((item, goodsIndex) => {
          return <div className="zero-mode-div seckill-style"
            key={item.form_data.id}
            style={{ marginTop: customFeature.margin, ...listStyleObj }}
            data-contact={customFeature.ifUseContact}
            data-formdata={JSON.stringify(item.form_data)}
            data-goods-type={item.form_data.goods_type}
            data-seckilltype={customFeature.seckillType == 'activeSeckill' ? 1 : 0}
            data-app-id={item.form_data.app_id}
            onClick={(e) => {this.goSeckillDetail(e);e.stopPropagation()}}>
            <img className="list-img" src={item.form_data.cover} style={imgStyleObj} />
            <div className="seckill-content">
              <div className="seckill-title">{item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : ''}{item.form_data.title}</div>
              <div className='seckill-content-bottom'>
                <div className='seckill-content-left'>
                  <div className={`seckill-now-price seckill-start-color-${item.form_data.seckill_start_state}`}>
                    <span className='font24'>¥</span>
                    <span>{item.form_data.seckill_price}</span>
                    <span className="seckill-original-price font24">¥{item.form_data.price}<span className="original-price-line"></span></span>
                  </div>
                  {item.form_data.seckill_start_state !== 0 &&
                    <div className={`seckill-progress-new seckill-progress-new-${item.form_data.seckill_progress}`}>
                      {item.form_data.seckill_progress != 100 &&
                        <img className="seckill-progress-image"
                          src='http://cdn.jisuapp.cn/static/jisuapp_editor/images/seckill-progress-red.png'
                          style={{ width: item.form_data.seckill_progress + '%' }} />
                      }
                      {item.form_data.seckill_progress == 100 && <img className="seckill-progress-image" src='http://cdn.jisuapp.cn/static/jisuapp_editor/images/seckill-progress-gray.png' />}
                      <div className="seckill-progress-font">
                        <div>已抢{item.form_data.seckill_activity_sales}件</div>
                        <div className={item.form_data.seckill_progress < 60 ? 'seckill-progress-percent' : ''}>{item.form_data.seckill_progress}%</div>
                      </div>
                    </div>
                  }
                  {item.form_data.seckill_start_state == 0 &&
                    <div className="seckill-describe">
                      {everyoneLimited && <div className="seckill-buy-limit">每人限抢{item.form_data.seckill_buy_limit}份</div>}
                      {everyoneLimited && limited && <div className="vertical-bar"></div>}
                      {limited && <div className="seckill-stock">限量{item.form_data.seckill_stock}</div>}
                    </div>
                  }
                  {item.form_data.seckill_start_state != 2 &&
                    <div className={`seckill-time seckill-start-color-${item.form_data.seckill_start_state}`}>
                      {item.form_data.seckill_start_state == 0 && item.form_data.startDay == 1 && <label>距开始</label>}
                      {item.form_data.seckill_start_state == 0 && item.form_data.startDay == 2 && <label>开抢时间</label>}
                      {item.form_data.seckill_start_state == 1 && <label>距结束</label>}
                      {(item.form_data.seckill_start_state == 1 || (item.form_data.seckill_start_state == 0 && item.form_data.startDay == 1)) &&
                        <span>
                          {!!item.form_data.downCount.days && <span className="days">{item.form_data.downCount.days}天</span>}
                          <span className="hours">{item.form_data.downCount.hours}</span>:
                          <span className="minutes">{item.form_data.downCount.minutes}</span>:
                          <span className="seconds">{item.form_data.downCount.seconds}</span>
                        </span>
                      }
                      {item.form_data.seckill_start_state == 0 && item.form_data.startDay == 2 && <span>{item.form_data.seckill_startTime}</span>}
                    </div>
                  }
                </div>
                <div className='seckill-content-right'>
                  {item.form_data.seckill_start_state == 1 && item.form_data.seckill_progress != 100 &&
                    <div className="seckill-button seckill-background-F23031">马上抢<label className="ico-moon icon-rightarrow icon-rightarrow-cover"></label></div>
                  }
                  {item.form_data.seckill_start_state == 1 && item.form_data.seckill_progress == 100 && <div className="seckill-button seckill-background-D0D0D0">已抢光</div>}
                  {item.form_data.seckill_start_state == 2 && <div className="seckill-button seckill-background-D0D0D0">已结束</div>}
                  {item.form_data.seckill_start_state == 0 && item.form_data.is_seckill_activity_care == 0 &&
                    <form>
                      <button className="form-button seckill-background-FF7100"
                        type="button"
                        data-goods={JSON.stringify(item.form_data)}
                        data-index={goodsIndex}
                        data-is_deleted="0"
                        data-compindex={this.props.index}
                        onClick={(e) =>{this.formSubmitRemind(e);e.stopPropagation()}}>
                        <div className="seckill-button">提醒我</div>
                      </button>
                    </form>
                  }
                  {item.form_data.seckill_start_state == 0 && item.form_data.is_seckill_activity_care == 1 &&
                    <form>
                      <button className="form-button seckill-background-FF7100"
                        type="button"
                        data-goods={JSON.stringify(item.form_data)}
                        data-index={goodsIndex}
                        data-is_deleted="1"
                        data-compindex={this.props.index}
                        onClick={(e) =>{this.formSubmitRemind(e);e.stopPropagation()}}>
                        <div className='seckill-button seckill-background-FF7100'>取消提醒</div>
                      </button>
                    </form>
                  }
                  {(item.form_data.seckill_start_state == 1 || item.form_data.seckill_progress == 100) && everyoneLimited &&
                    <div className="seckill-content-right-describe">每人限抢{item.form_data.seckill_buy_limit}份</div>
                  }
                  {item.form_data.seckill_start_state == 0 && item.form_data.seckill_activity_care > 0 && peopleCounting &&
                    <div className="seckill-content-right-describe">{item.form_data.seckill_activity_care}人已设置</div>
                  }
                </div>
              </div>
            </div>
            <div className='seckill-bottom-line'></div>
          </div>
        })}

      </div>
    );

    const modeOneAndTwo = () => (
      <div className={mode == 1 ? '' : 'two-mode-div-block'}>
        {goods_data && goods_data.map((item, goodsIndex) => {
          return <div className={`seckill-style ${mode == 1 ? 'one-mode-div' : 'two-mode-div'}`}
            key={item.form_data.id}
            style={{ width: mode === 2 ? title_width.width : '', ...listStyleObj }}
            data-formdata={JSON.stringify(item.form_data)}
            data-contact={customFeature.ifUseContact}
            data-goods-type={item.form_data.goods_type}
            data-seckilltype={customFeature.seckillType == 'activeSeckill' ? 1 : 0}
            data-app-id={item.form_data.app_id}
            onClick={(e) => {this.goSeckillDetail(e);e.stopPropagation()}}>
            <div className="seckill-image-content">
              <div className="image-content" style={imgStyleObj}>
                <img className="list-img" src={item.form_data.cover} style={imgStyleObj} />
                {item.form_data.seckill_start_state != 2 &&
                  <div className={`seckill-time ${item.form_data.seckill_start_state != 0 ? 'seckill-background-F23031' : ''} ${item.form_data.seckill_start_state == 0 ? 'seckill-background-FF7100' : ''}`}>
                    {item.form_data.seckill_start_state == 0 && <label>距开始</label>}
                    {item.form_data.seckill_start_state == 1 && <label>距结束</label>}
                    {item.form_data.seckill_start_state != 2 &&
                      <span>
                        {!!item.form_data.downCount.days && <span className="days">{item.form_data.downCount.days}天</span>}
                        <span className="hours countdown-text">{item.form_data.downCount.hours}</span>:
                          <span className="minutes countdown-text">{item.form_data.downCount.minutes}</span>:
                          <span className="seconds countdown-text">{item.form_data.downCount.seconds}</span>
                      </span>
                    }
                  </div>
                }
              </div>
            </div>
            <div className="seckill-content">
              <div className="seckill-title">{item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : ''}{item.form_data.title}</div>
              {item.form_data.seckill_start_state == 0 &&
                <div className={`seckill-progress-new ${mode == 1 ? 'seckill-matop4' : 'seckill-matop2'} seckill-progress-new-ready`}>未开始</div>
              }
              {item.form_data.seckill_start_state != 0 &&
                <div className={`seckill-progress-new ${mode == 1 ? 'seckill-matop4' : 'seckill-matop2'} seckill-progress-new-${item.form_data.seckill_progress}`}>
                  {item.form_data.seckill_progress != 100 &&
                    <img className="seckill-progress-image"
                      src='http://cdn.jisuapp.cn/static/jisuapp_editor/images/seckill-progress-red.png'
                      style={{ width: item.form_data.seckill_progress + '%' }} />
                  }
                  {item.form_data.seckill_progress == 100 &&
                    <img className="seckill-progress-image"
                      src='http://cdn.jisuapp.cn/static/jisuapp_editor/images/seckill-progress-gray.png' />
                  }
                  <div className="seckill-progress-font">
                    <div>已抢{item.form_data.seckill_activity_sales}件</div>
                    <div className={item.form_data.seckill_progress < 60 ? 'seckill-progress-percent' : ''}>{item.form_data.seckill_progress}%</div>
                  </div>
                </div>
              }
              <div className="seckill-describe seckill-matop8">
                {everyoneLimited && <div className="seckill-buy-limit">每人限抢{item.form_data.seckill_buy_limit}份</div>}
                {everyoneLimited && item.form_data.seckill_start_state == 0 && limited && <div className="vertical-bar"></div>}
                {item.form_data.seckill_start_state == 0 && limited && <div className="seckill-stock">限量{item.form_data.seckill_stock}</div>}
              </div>
              <div className={`seckill-now-price seckill-start-color-${item.form_data.seckill_start_state} seckill-matop4`}>
                <div style={{ display: 'inline-block' }}>
                  <span className="font24">¥</span>
                  <span >{item.form_data.seckill_price}</span>
                </div>
                <div className="seckill-original-price font22">¥{item.form_data.price}<span className="original-price-line"></span></div>
              </div>
              {item.form_data.seckill_start_state == 1 && item.form_data.seckill_progress != 100 && <div className="seckill-button seckill-background-F23031">马上抢</div>}
              {item.form_data.seckill_start_state == 1 && item.form_data.seckill_progress == 100 && <div className="seckill-button seckill-background-D0D0D0">已抢光</div>}
              {item.form_data.seckill_start_state == 2 && <div className="seckill-button seckill-background-D0D0D0">已结束</div>}
              {item.form_data.seckill_start_state == 0 &&
                <div className="seckill-button-box">
                  {item.form_data.is_seckill_activity_care == 0 &&
                    <form>
                      <button
                        type="button"
                        className="form-button"
                        data-goods={JSON.stringify(item.form_data)}
                        data-index={goodsIndex}
                        data-is_deleted="0"
                        data-compindex={this.props.index}
                        onClick={(e) => {this.formSubmitRemind(e);e.stopPropagation()}}>
                        <span className='seckill-button-new seckill-background-FF7100'>提醒我</span>
                      </button>
                    </form>
                  }
                  {item.form_data.is_seckill_activity_care == 1 &&
                    <form>
                      <button
                        type="button"
                        className="form-button"
                        data-goods={JSON.stringify(item.form_data)}
                        data-index={goodsIndex}
                        data-is_deleted="1"
                        data-compindex={this.props.index}
                        onClick={(e) => {this.formSubmitRemind(e);e.stopPropagation()}}>
                        <span className='seckill-button-new seckill-background-FF7100'>取消提醒</span>
                      </button>
                    </form>
                  }
                  {item.form_data.seckill_activity_care > 0 && peopleCounting && <span className="seckill-content-right-describe">{item.form_data.seckill_activity_care}人已设置</span>}
                </div>
              }
            </div>
          </div>
        })}
      </div>
    );

    const modeThree = () => (
      <div>
        {goods_data && goods_data.map((item, goodsIndex) => {
          return <div className="three-mode-div seckill-style"
            key={item.form_data.id}
            style={listStyleObj}
            data-formdata={JSON.stringify(item.form_data)}
            data-contact={customFeature.ifUseContact}
            data-goods-type={item.form_data.goods_type}
            data-seckilltype={customFeature.seckillType == 'activeSeckill' ? 1 : 0}
            data-app-id={item.form_data.app_id}
            onClick={(e) => {this.goSeckillDetail(e);e.stopPropagation()}}>
            <div className="seckill-image-content">
              {item.form_data.seckill_start_state != 2 &&
                <div className={`seckill-time ${item.form_data.seckill_start_state != 0 ? 'seckill-background-F23031' : ''} ${item.form_data.seckill_start_state == 0 ? 'seckill-background-FF7100' : ''}`}>
                  {item.form_data.seckill_start_state == 0 && <label>距开始</label>}
                  {item.form_data.seckill_start_state == 1 && <label>距结束</label>}
                  {!!item.form_data.downCount.days && <span className="days">{item.form_data.downCount.days}天</span>}
                  <span className={`hours countdown-text ${item.form_data.seckill_start_state == 1 ? 'seckill-background-CD0C0E' : ''}`}>{item.form_data.downCount.hours}</span>:
                  <span className={`minutes countdown-text ${item.form_data.seckill_start_state == 1 ? 'seckill-background-CD0C0E' : ''}`}>{item.form_data.downCount.minutes}</span>:
                  <span className={`seconds countdown-text ${item.form_data.seckill_start_state == 1 ? 'seckill-background-CD0C0E' : ''}`}>{item.form_data.downCount.seconds}</span>
                </div>
              }
              <div className="image-content" style={imgStyleObj}>
                <img className="list-img" src={item.form_data.cover} style={imgStyleObj} />
              </div>
            </div>
            <div className="seckill-content">
              <div className="seckill-title">{item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : ''}{item.form_data.title}</div>
              <div className='seckill-content-bottom'>
                <div className="seckill-content-left" >
                  <div className={`seckill-now-price seckill-start-color-${item.form_data.seckill_start_state}`}>
                    <span className='font24'>¥</span>
                    <span>{item.form_data.seckill_price}</span>
                    <span className="seckill-original-price font24">¥{item.form_data.price}<span className="original-price-line"></span></span>
                  </div>
                  <div className='seckill-items-center seckill-matop2'>
                    {item.form_data.seckill_start_state == 1 &&
                      <div className='seckill-progress-new'>
                        {item.form_data.seckill_progress != 100 &&
                          <img className="seckill-progress-image"
                            src='http://cdn.jisuapp.cn/static/jisuapp_editor/images/seckill-progress-red.png'
                            style={{ width: item.form_data.seckill_progress + '%' }} />
                        }
                        {item.form_data.seckill_progress == 100 && <img className="seckill-progress-image" src='http://cdn.jisuapp.cn/static/jisuapp_editor/images/seckill-progress-gray.png' />}
                        <div className="seckill-progress-font">
                          <div>已抢{item.form_data.seckill_activity_sales}件</div>
                          <div className={item.form_data.seckill_progress < 60 ? 'seckill-progress-percent' : ''}>{item.form_data.seckill_progress}%</div>
                        </div>
                      </div>
                    }
                    {everyoneLimited && <div className={`seckill-buy-limit ${item.form_data.seckill_start_state == 1 ? 'seckill-buy-limit-new' : ''}`}>每人限抢{item.form_data.seckill_buy_limit}份</div>}
                    {everyoneLimited && item.form_data.seckill_start_state == 0 && limited && <div className="vertical-bar"></div>}
                    {item.form_data.seckill_start_state == 0 && limited && <div className="seckill-stock">限量{item.form_data.seckill_stock}</div>}
                  </div>
                </div>
                <div className="seckill-content-right" >
                  {item.form_data.seckill_start_state == 0 && item.form_data.seckill_activity_care > 0 && peopleCounting &&
                    <div className="seckill-content-right-describe">{item.form_data.seckill_activity_care}人已设置</div>
                  }
                  {item.form_data.seckill_start_state == 1 && item.form_data.seckill_progress != 100 &&
                    <div className="seckill-button seckill-background-F23031">马上抢<label className="ico-moon icon-rightarrow icon-rightarrow-cover"></label></div>
                  }
                  {item.form_data.seckill_start_state == 1 && item.form_data.seckill_progress == 100 && <div className="seckill-button  seckill-background-D0D0D0">已抢光</div>}
                  {item.form_data.seckill_start_state == 2 && <div className="seckill-button  seckill-background-D0D0D0">已结束</div>}
                  {item.form_data.seckill_start_state == 0 && item.form_data.is_seckill_activity_care == 0 &&
                    <form>
                      <button
                        type="button"
                        className="form-button"
                        data-goods={JSON.stringify(item.form_data)}
                        data-index={goodsIndex}
                        data-is_deleted="0"
                        data-compindex={this.props.index}
                        onClick={(e) => {this.formSubmitRemind(e);e.stopPropagation()}}>
                        <div className='seckill-button seckill-background-FF7100' >提醒我</div>
                      </button>
                    </form>
                  }
                  {item.form_data.seckill_start_state == 0 && item.form_data.is_seckill_activity_care == 1 &&
                    <form>
                      <button
                        type="button"
                        className="form-button"
                        data-goods={JSON.stringify(item.form_data)}
                        data-index={goodsIndex}
                        data-is_deleted="1"
                        data-compindex={this.props.index}
                        onClick={(e) => {this.formSubmitRemind(e);e.stopPropagation()}}>
                        <div className='seckill-button seckill-background-FF7100' >取消提醒</div>
                      </button>
                    </form>
                  }
                </div>
              </div>
            </div>
          </div>
        })}
      </div>
    );

    const wrap = () => (
      <div className="js-list-container">
        {goods_data && goods_data.map((item) => {
          return <div className="seckill-list-item background-ele"
            key={item.form_data.id}
            style={listStyleObj}
            data-formdata={JSON.stringify(item.form_data)}
            data-contact={customFeature.ifUseContact}
            data-goods-type={item.form_data.goods_type}
            data-seckilltype={customFeature.seckillType == 'activeSeckill' ? 1 : 0}
            data-app-id={item.form_data.app_id}
            onClick={(e) => {this.goSeckillDetail(e);e.stopPropagation()}}>
            <div className="inner-content">
              <img className="list-img" src={item.form_data.cover} style={imgStyleObj} />
              <div className="title-container" style={{ width: title_width.width }}>
                <div className="title">{item.form_data.title}</div>
                {(mode == 1 || mode == 2)
                  ?
                  <div className={`seckill-list-bottom ${item.form_data.seckill_start_state == 1 ? 'seckill-during' : ''}
                                                       ${item.form_data.seckill_start_state == 2 ? 'seckill-end' : ''}`}>
                    <div>
                      <span className="price">¥{item.form_data.seckill_price}</span>
                      <span className="oldprice">¥{item.form_data.price}</span>
                    </div>
                    <div>
                      <div className="seckill-progress-wrap">
                        <span>已售{item.form_data.seckill_progress}%</span>
                        <Progress
                          className="seckill-progress"
                          unfilled={false}
                          percent={item.form_data.seckill_progress}
                          barStyle={{ borderColor: '#fa6583' }} 
                          position="normal" />
                      </div>
                      <div className="countdown">
                        {item.form_data.seckill_start_state == 0 && <label>距开始</label>}
                        {item.form_data.seckill_start_state == 1 && <label>距结束</label>}
                        {item.form_data.seckill_start_state == 2 && <label>已结束</label>}
                        {!!item.form_data.downCount.days && <span className="days">{item.form_data.downCount.days}天</span>}
                        {item.form_data.seckill_start_state != 2 && <span className="hours countdown-text">{item.form_data.downCount.hours}</span>}:
                        <span className="minutes countdown-text">{item.form_data.downCount.minutes}</span>:
                        <span className="seconds countdown-text">{item.form_data.downCount.seconds}</span>
                      </div>
                    </div>
                  </div>
                  :
                  <div className={`seckill-list-bottom ${item.form_data.seckill_start_state == 1 ? 'seckill-during' : ''}
                                                       ${item.form_data.seckill_start_state == 2 ? 'seckill-end' : ''}`}
                    style={{ width: title_width.width }}>
                    <div>
                      <span className="price">¥{item.form_data.seckill_price}</span>
                      <div className="countdown">
                        {item.form_data.seckill_start_state == 0 && <label>距开始</label>}
                        {item.form_data.seckill_start_state == 1 && <label>距结束</label>}
                        {item.form_data.seckill_start_state == 2 && <label>已结束</label>}
                        {!!item.form_data.downCount.days && <span className="days">{item.form_data.downCount.days}天</span>}
                        {item.form_data.seckill_start_state != 2 && <span className="hours countdown-text">{item.form_data.downCount.hours}</span>}:
                        <span className="minutes countdown-text">{item.form_data.downCount.minutes}</span>:
                        <span className="seconds countdown-text">{item.form_data.downCount.seconds}</span>
                      </div>
                    </div>
                    <div className="oldPrice-wrap">
                      <span className="oldprice">¥{item.form_data.price}</span>
                      <div className="seckill-progress-wrap flex-wrap">
                        <span>已售{item.form_data.seckill_progress}%</span>
                        <Progress
                          className="seckill-progress"
                          position="normal"
                          unfilled={false}
                          percent={item.form_data.seckill_progress}
                          barStyle={{ borderColor: '#fa6583' }} />
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        })}
      </div>
    );


    return <div className="custom-component seckill">
      {customFeature.style == 2
        ?
        <ScrollView
          className={`element seckill scroll-ele sec-style-mode-${mode}`}
          data-param={data.param}
          data-compindex={this.props.index}
          data-type="seckill-list"
          style={styleObj}
          scroll-y={mode == 2 || customFeature.vesselAutoheight != 0 ? false : true}
          scroll-x={mode == 2 ? true : false}
          lower-threshold="10"
          bindscrolltolower={this.seckillScrollFunc}
          // bindanimationend="animationEnd"
          >
          {mode === 0 && modeZero()}
          {(mode === 1 || mode === 2) && modeOneAndTwo()}
          {mode === 3 && modeThree()}
        </ScrollView>
        :
        <ScrollView
          className={`element seckill scroll-ele seckill-list-mode-${mode} ${(mode == 2 && curpage > 0) ? 'hor-request-status' : ''}`}
          style={styleObj}>
          {wrap()}
        </ScrollView>
      }
      {/* 加载loading */}
      {
          data.loading && 
          <RequestStatus is="requestLoading"></RequestStatus>
        }
        {/* 加载没有数据 */}
        {
          data.is_more == 0 && data.goods_data.length == 0 &&
          <RequestStatus is="requestNone" data={{ data: '暂无秒杀商品~'}}></RequestStatus>
        }
        {/* 加载失败 */}
        {
          data.loadingFail &&
          <RequestStatus is="requestFail" data={{refreshEvent: 'seckillScrollFunc', compindex: this.props.index}}></RequestStatus>
        }
        {/* 加载完所有数据 */}
        {
          data.is_more == 0 && data.goods_data.length > 0 && data.customFeature.isShowFinishText &&
          <RequestStatus is="requestAll"></RequestStatus>
        }
        {/* 点击加载按钮 */}
        {
          data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && data.customFeature.mode != 2 && !!data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail &&
          <LoadingBtn customFeature={customFeature} onClick={this.seckillScrollFunc} data-compindex={this.props.index}></LoadingBtn>
        }
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/seckill-custom-component/SeckillCustomComponent.jsx